import React from 'react';
import { translate } from 'react-i18next';
import { Image, Label, Icon, Button } from 'semantic-ui-react';

import RewardClaimModal from './RewardClaimModal.js';
import LoadInline from '../loading/LoadInline.js';

import {colors, spacings, shadow, fontSizes, fonts} from 'style';

var style = {
    item: {
        position: 'relative',
        overflow:'hidden',
        border: '1px solid ' + colors.themeDarkGrey,
        borderRadius: '10px',
        padding: spacings.base,
        margin: spacings.small,
        minHeight: '130px',
        lineHeight: '1.5',
    },
    imageArea: {
        position: 'absolute',
        top: '0px',
        display: 'inline-block',
        width:'120px', 
        height:'100%', 
        lineHeight:'60px', 
    },
    image: {
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-30px',
        height: '60px',
        fontSize: '60px',
        lineHeight: '1',
    },
    tagArea: {
        position: 'absolute',
        top: '0px',
        right: '220px',
        display: 'inline-block',
        height: '100%',
        lineHeight: '130px',
    },
    tags: {
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-38px',
        height: '90px',
    },
    costLabel: {
        display: 'block',
        minWidth: '50px',
        fontWeight: 'normal',
        fontSize: '0.85em',
        //border: '2px solid ' + colors.themeBlue,
        backgroundColor: colors.themeBlue,
        color: '#fff',
        borderRadius: '100px',
        marginBottom: spacings.small,
    },
    costIcon: {
        margin:'0px',
        backgroundColor: colors.themeBlue,
        color: '#fff',
    },
    priceTag: {
        display: 'block',
        marginTop: spacings.small,
    },
    buttonArea: {
        position: 'absolute',
        top: '0px',
        right: spacings.small,
        display: 'inline-block',
        width: '170px',
        height: '100%',
        lineHeight: '40px',
    },
    claimButton: {
        backgroundColor: colors.themeTeal,
        color: '#fff',
        fontWeight: 'normal',
        display: 'block',
        position: 'relative',
        top: '50%',
        marginTop: '-25px',
        width: '100%',
        borderRadius: '100px',
        boxShadow: shadow,
        ...fonts.body,
        lineHeight: '1.5',
    },
    resources: {
        float: 'right',
        paddingLeft: '10px',
        paddingRight: '5px',
    },
    textArea: {
        verticalAlign: 'top',
        display: 'inline-block',
        lineHeight: '1.5',
        paddingLeft: '140px',
        paddingRight: '190px',
    },
    title: {
        color: colors.themeBlue,
    },
    description: {
    },
};

const Rewards = ({t, reward, claimButtonDisable, onRedeemReward}) => (
        <div style={style.item}>
            <div style={style.imageArea} className='rewards-imageArea'>
                <Image style={style.image} src={reward.logoUrl} alt=""/>
            </div>
            <div style={style.textArea} className='rewards-textArea'>
                <div style={style.title}>{reward.title}</div>
                <div style={style.description}>{reward.description}</div>
            </div>
            <div style={style.tagArea} className='rewards-tagArea'>
                <div style={style.tags}>
                    <Label style={style.costLabel} size="large">
                        <Icon style={style.costIcon} className="icon-Optimollar"/>
                        <span style={style.resources}>{reward.resources} </span>
                    </Label>
                    <Label style={style.priceTag} tag size="large">${reward.price / 100}</Label><br/>
                </div>
            </div>
            <div style={style.buttonArea} className='rewards-buttonArea'>
                <Button style={style.claimButton} disabled={claimButtonDisable(reward)} onClick={()=>{onRedeemReward(reward)}}>{t('Claim')}</Button>
            </div>
        </div>
);


export default translate('rewards')(Rewards);



// WEBPACK FOOTER //
// ./src/modules/rewards/RewardItem.js